import { useEffect, useState } from "react";
import { useMessageBus } from "@jti/fe-message-bus";
export const useProductDetails = (config) => {
    const { sku, priceInformation, hidePrice } = config;
    const messageBus = useMessageBus();
    const [isCartLoaded, setIsCartLoaded] = useState(false);
    const [quantityLimit, setQuantityLimit] = useState(0);
    const [isQuantityLimitReached, setIsQuantityLimitReached] = useState(false);
    const isZeroPrice = priceInformation?.finalPrice?.value === 0;
    const isHiddenZeroPrice = isZeroPrice && hidePrice;
    useEffect(() => {
        messageBus.subscribe({
            channel: "cart.limit.update",
            callback: ({ payload }) => {
                if (sku === payload.sku) {
                    setQuantityLimit(payload.limit);
                    setIsQuantityLimitReached(payload.quantityLimitReached);
                }
            },
        });
        messageBus.subscribe({
            channel: "cart.loaded",
            callback: () => {
                setIsCartLoaded(true);
            },
        });
        return () => {
            messageBus.unsubscribe("cart.loaded");
            messageBus.unsubscribe("cart.limit.update");
        };
    }, []);
    return {
        isCartLoaded,
        quantityLimit,
        isQuantityLimitReached,
        shouldRenderPrice: !isHiddenZeroPrice,
    };
};
//# sourceMappingURL=useProductDetails.js.map